import React from 'react';
import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';
import ProgressBar from './ProgressBar';
import { Description, HeadingContent, Wrapper } from '../Banners.styles';

type OwnProps = React.PropsWithChildren<{
  currentStep: number;
}>;

export default function DelayedDisplayWrapper({
  currentStep,
  children
}: OwnProps) {
  const { currentWipStatus: { isDelayed = false } = {} } =
    useVehicleAvailability();

  return isDelayed ? (
    <Wrapper className="gap-2xl">
      <div className="flex flex-col gap-md ">
        <HeadingContent>We’re working on it</HeadingContent>
        <Description>
          Our rigorous inspection and detailing process is taking longer than
          expected. Rest assured, our team is working hard to provide your
          exclusive preview.
        </Description>
      </div>
      <ProgressBar currentStep={currentStep} />
    </Wrapper>
  ) : (
    children
  );
}
